import { t } from "@/i18n-js/instance";
import { CreditCardIcon } from "@circle-react-shared/CreditCardIcon";
import { Typography } from "@circle-react-uikit/Typography";

const localeStringRoot =
  "settings.paywalls_admin_dashboard.charges.charge_details_modal";

export const LinkProperty = () => (
  <div className="flex flex-row items-center gap-x-1">
    <CreditCardIcon walletType="link" hideCard />
    <Typography.BodySm>
      {t([localeStringRoot, "details_labels.payment_method.link"])}
    </Typography.BodySm>
  </div>
);
